import {
  Signer,
  Transaction,
  TransactionInstruction,
  TransactionSignature,
  VersionedTransaction,
} from '@solana/web3.js';

export const getEmptyInstruction: () => Instruction = () => ({
  setupInstructions: [],
  instructions: [],
  cleanupInstructions: [],
  signers: [],
});

export type Instruction = {
  setupInstructions: TransactionInstruction[];
  instructions: TransactionInstruction[];
  cleanupInstructions: TransactionInstruction[];
  signers: Signer[];
};

export type TransactionPayload = {
  transaction: Transaction | VersionedTransaction;
  signers: Signer[];
  execute: () => Promise<TransactionSignature>;
};
